import './facebook.css';

export default ({ widget }) => {
    return <div class="facebook-post-container" dangerouslySetInnerHTML={{__html: widget}}/>
}